import React from "react";
import Chip from "@material-ui/core/Chip";
import { i18n } from "../../../translate/i18n";

const CampaignStatusChip = ({ status, classes }) => {
  switch (status) {
    case "INATIVA":
      return (
        <Chip
          label={`⏸️ ${i18n.t("campaigns.report.statusValues.inactive")}`}
          className={`${classes.statusChip} ${classes.statusInactive}`}
          size="small"
        />
      );
    case "PROGRAMADA":
      return (
        <Chip
          label={`📅 ${i18n.t("campaigns.report.statusValues.scheduled")}`}
          className={`${classes.statusChip} ${classes.statusScheduled}`}
          size="small"
        />
      );
    case "EM_ANDAMENTO":
      return (
        <Chip
          label={`▶️ ${i18n.t("campaigns.report.statusValues.inProgress")}`}
          className={`${classes.statusChip} ${classes.statusInProgress}`}
          size="small"
        />
      );
    case "CANCELADA":
      return (
        <Chip
          label={`❌ ${i18n.t("campaigns.report.statusValues.cancelled")}`}
          className={`${classes.statusChip} ${classes.statusCancelled}`}
          size="small"
        />
      );
    case "FINALIZADA":
      return (
        <Chip
          label={`✅ ${i18n.t("campaigns.report.statusValues.finished")}`}
          className={`${classes.statusChip} ${classes.statusFinished}`}
          size="small"
        />
      );
    default:
      return status;
  }
};

export default CampaignStatusChip;
